import { Language, Locale } from 'interfaces/language';
import { languageOptions } from 'languages';

export function formatUserLocale(userLanguage: Language): string {
  const defaultUserLocale: Locale = 'en-US';

  if (userLanguage in languageOptions) {
    return languageOptions[userLanguage];
  }

  return defaultUserLocale;
}
